import { IUniversityFilterProvider } from '@studyportals/search-filters';
import { IUniversityInfo } from '@studyportals/search-filters/dist/src/models/IUniversityInfo';
import { injectable } from 'inversify';
import { DomainApiProjectionOrganisationForSearch } from '@/infrastructure/DomainApiProjectionOrganisationForSearch';
import { FilterOptions } from '@/filters/options/FilterOptions';

@injectable()
export class UniversityFilterProvider implements IUniversityFilterProvider {
	private readonly domainApiProjection: DomainApiProjectionOrganisationForSearch;
	private readonly filterOptions: FilterOptions;

	public constructor(domainApiProjection: DomainApiProjectionOrganisationForSearch, filterOptions: FilterOptions) {
		this.domainApiProjection = domainApiProjection;
		this.filterOptions = filterOptions;
	}

	public async retrieveUniversityInfo(id: string): Promise<IUniversityInfo | null> {
		const organisation = await this.domainApiProjection.retrieveOrNull(id);
		if (organisation === null) {
			return null;
		}

		const isoCodesOfCountryOptions = organisation.getIsoCodesOfCountriesOfVenues();
		const valuesOfCountryOptions = this.filterOptions.getValuesOfCountryOptionsForIsoCodes(isoCodesOfCountryOptions);

		return {
			id: `${organisation.getOrganisationId()}`,
			name: organisation.getOrganisationName(),
			valuesOfCountryOptions,
		};
	}
}
